import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M1.19 6.783A11.95 11.95 0 0 0 0 12c0 1.87.428 3.64 1.19 5.218L12 18.26l10.81-1.043A11.95 11.95 0 0 0 24 12c0-1.87-.428-3.64-1.19-5.217L12 5.739z\"></path><path fill=\"#000\" d=\"M1.191 17.217a12 12 0 0 0 10.81 6.782 12 12 0 0 0 10.808-6.782z\"></path><path fill=\"#D80027\" d=\"M1.191 6.783H22.81A12 12 0 0 0 12 0 12 12 0 0 0 1.191 6.783\"></path><path fill=\"#496E2D\" d=\"M3.515 3.514c-4.687 4.686-4.687 12.285 0 16.97L12 12z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }